const HeroCarouselSlideTwo = () => {
  const handleNavigation = (e, url) => {
    e.stopPropagation();
    window.location.href = url;
  };

  return (
    <div className='carousel__slide-box carousel__box-two'>
      <div className='carousel__texts-box carousel__box-two--texts'>
        <p className='carousel__slide-sub--text slide__3-text--1'>
          Import & export large and heavy packages from as low as
        </p>
        <div className='slide__3-main-texts'>
          <h1 className='carousel__slide-main--text slide__3-main-text'>
            ₦600
          </h1>
          <p className='slide__3-main-text-small'>per kg</p>
        </div>
        <div className='hero__section-hero--section__ctas'>
          <button
            className='hero__carousel-cta slide__3-cta'
            onClick={e => handleNavigation(e, 'https://ship.topship.africa')}
          >
            Start Shipping
          </button>
        </div>
      </div>
    </div>
  );
};

export default HeroCarouselSlideTwo;
